import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import About from "./components/About";
import Channels from "./components/Channels";
import Guide from "./components/Guide";
import Scope from "./components/Scope";
import Principles from "./components/Principles";
import Testimonials from "./components/Testimonials";
import Faq from "./components/Faq";
import Footer from "./components/Footer";

export default function Home() {
  return (
    <div className="flex min-h-screen flex-col bg-background-50">
      <Navbar />
      <main>
        <Hero />
        <About />
        <Channels />
        <Guide />
        <Scope />
        <Principles />
        <Testimonials />
        <Faq />
      </main>
      <Footer />
    </div>
  );
}